import React, { useEffect, useRef } from "react";
import "./HomePage.css";

const platforms = [
  {
    img: "/kuku-assets/images/amazon-600px.png",
    alt: "Amazon",
    href: "https://www.amazon.in/stores/KukuNamkeen/page/C337DF88-0254-4F8D-B8BC-0E12C5B755F7?lp_asin=B0DHSCRQKD&ref_=ast_bln",
    isLink: true,
  },
  {
    img: "/kuku-assets/images/zomato-600px.png",
    alt: "Zomato",
    href: "#",
    isLink: false,
  },
  {
    img: "/kuku-assets/images/mirchi-logo-600px.png",
    alt: "Mirchi",
    href: "#",
    isLink: false,
  },
];

const AlsoAvailableSection = ({
  containerClassName = "container",
  sectionClassName = "",
}) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("active");
          } else {
            e.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <section
      className={`hp-available hp-section hp-reveal ${sectionClassName}`.trim()}
      ref={sectionRef}
      style={{ backgroundColor: "#f8fad6" }}
    >
      <div className={containerClassName}>
        <h2 className="hp-available-heading">We are also available on</h2>
        <div className="hp-available-row">
          {platforms.map((p, i) =>
            p.isLink ? (
              <div key={i} className="hp-available-col">
                <a href={p.href} target="_blank" rel="noreferrer">
                  <img src={p.img} alt={p.alt} className="hp-platform-img" />
                </a>
              </div>
            ) : (
              <div key={i} className="hp-available-col">
                <img src={p.img} alt={p.alt} className="hp-platform-img" />
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default AlsoAvailableSection;
